<script lang="ts">
    import { events, articles } from "../../store"

    import Sidebar from "../page/Sidebar.svelte"
    import Article from "../page/Article.svelte"
    import Event from "../page/Event.svelte"
    import CloudCarousel from "../page/CloudCarousel.svelte"
</script>

<div class="top-article mb-xl">
    <div class="articles">
        {#each $articles || [] as article}
            {#if article.position === "top"}
                <Article article="{article}" />
            {/if}
        {/each}
    </div>
    <div
        class="wave-bottom"
        style="background-image: url('/assets/page/wave_header_bottom.png');"
    ></div>
</div>

<div class="container">
    <div class="row">
        <div class="col-md-10">
            <div class="top-of-content">
                {#each $articles || [] as article}
                    {#if article.position === "top-of-content"}
                        <Article article="{article}" />
                    {/if}
                {/each}
            </div>

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div>
                {#each $articles || [] as article}
                    {#if article.position === "content"}
                        <Article article="{article}" />
                    {/if}
                {/each}
            </div>

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div class="layout layout-vertical layout-gap-md">
                <h2>Veranstaltungen</h2>
                {#each $events || [] as event}
                    {#if event.position === "content"}
                        <Event event="{event}" />
                    {/if}
                {/each}
            </div>

            <img
                src="assets/page/notes.svg"
                alt="Svend Walter - Noten"
                class="mt-lg mb-lg"
            />

            <div class="layout layout-vertical layout-gap-md mb-lg">
                <h2>Der Thüringer Wald - da, wo ich zu Hause bin.</h2>
                {#each $articles || [] as article}
                    {#if article.position === "end-of-content"}
                        <Article article="{article}" />
                    {/if}
                {/each}
            </div>

            <div class="mt-lg mb-lg">
                <CloudCarousel />
            </div>
        </div>
        <div class="col-md-2">
            <Sidebar />
        </div>
    </div>
</div>
